<template>
  <el-card>
    <el-form class="global-form2" ref="form" :model="formData" :rules="rules" label-width="100px"
      label-position="right">
      <el-form-item label="物料编码" prop="materialCode">
        <el-input v-model="formData.materialCode" placeholder="请输入物料编码"></el-input>
      </el-form-item>
      <el-form-item label="物料名称" prop="materialName">
        <el-input v-model="formData.materialName" placeholder="请输入物料名称"></el-input>
      </el-form-item>
      <el-form-item label="物料分类" prop="materialTypeId">
        <el-cascader v-model="formData.materialTypeId" :props="props" :options="materialTypeData"></el-cascader>
      </el-form-item>
      <el-form-item label="规格" prop="specifications">
        <el-input v-model="formData.specifications" placeholder="请输入规格"></el-input>
      </el-form-item>
      <el-form-item label="品牌名称" prop="brand">
        <el-input v-model="formData.brand" placeholder="请输入单位"></el-input>
      </el-form-item>
      <el-form-item label="单位" prop="company">
        <el-input v-model="formData.company" placeholder="请输入单位"></el-input>
      </el-form-item>
      <el-form-item label="供应商名称" prop="supplierId">
        <el-select clearable v-model="formData.supplierId" filterable placeholder="请选择供应商">
          <el-option v-for="item in supplierData" :key="item.supplierId" :label="item.supplierName"
            :value="item.supplierId" clearable></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="状态" prop="isStop">
        <el-switch v-model="formData.isStop" :active-value="0" :inactive-value="1"
          @change="handleSwitchChange"></el-switch>
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" @click="submit">保存</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        materialName: '', // 物料名称
        materialCode: '', // 物料编码
        materialTypeId: '', // 物料分类
        company: '', // 单位
        brand: '', // 品牌
        specifications: '', // 规格
        supplierId: '', // 供应商id
        supplierName: '', // 供应商名称
        isStop: 0 // 状态0启用1禁用
      },
      props: {
        value: 'materialTypeId',
        label: 'materialTypeName',
        children: 'childNode',
        emitPath: false,
        checkStrictly: true
      },
      supplierData: [],
      materialTypeData: [],
      rules: {
        materialName: [
          { required: true, message: '请输入物料名称', trigger: 'blur' }
        ],
        materialCode: [
          { required: true, message: '请输入物料编码', trigger: 'blur' }
        ],
        materialTypeId: [
          { required: true, message: '请选择物料分类', trigger: 'blur' }
        ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'blur' }
        ],
        // supplierId: [
        //   { required: true, message: '请选择供应商', trigger: 'blur' }
        // ],
        isStop: [
          { required: true, message: '请选择状态', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    materialId() {
      return this.$route.query.materialId
    }
  },
  created() {
    if (this.materialId) {
      this.loadData()
    }
    this.loadMaterialType()
    this.loadSupplierType()
  },
  methods: {
    loadData() {
      this.$axios.get(this.$apis.material.selectYhMaterialByMaterialId, {
        materialId: this.materialId
      }).then(res => {
        this.formData = res
      })
    },
    loadMaterialType() {
      this.$axios.get(this.$apis.material.selectYhMaterialTypeByList).then(res => {
        this.materialTypeData = res
      })
    },
    loadSupplierType() {
      this.$axios.get(this.$apis.material.selectYhSupplierByPage).then(res => {
        this.supplierData = res.list
      })
    },
    // handleSwitchChange(event) {
    //   if (this.materialId) {
    //     this.$axios.post(this.$apis.material.stopYhMaterial, event)
    //   }
    // },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = this.materialId ? this.$apis.material.updateYhMaterial : this.$apis.material.insertYhMaterial
          console.log(this.formData);
          this.$axios.post(url, this.formData).then(() => {
            this.$router.back()
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss"></style>